import { api } from '@/lib/api';
import type {
  CreateOfferingInput,
  DiningOffering,
  DiningProfile,
  DiningProfileUpdate,
  OfferingAvailability,
  PublicOffering,
  UpdateOfferingInput,
} from './types';

// ---- Vendor management ----
export async function fetch_dining_profile(): Promise<DiningProfile> {
  const res = await api.get<DiningProfile>('/vendor/dining/profile');
  return res.data;
}

export async function save_dining_profile(input: DiningProfileUpdate): Promise<DiningProfile> {
  const res = await api.put<DiningProfile>('/vendor/dining/profile', input);
  return res.data;
}

export async function fetch_offerings(): Promise<DiningOffering[]> {
  const res = await api.get<DiningOffering[]>('/vendor/dining/offerings');
  return res.data;
}

export async function create_offering(input: CreateOfferingInput): Promise<DiningOffering> {
  const res = await api.post<DiningOffering>('/vendor/dining/offerings', input);
  return res.data;
}

export async function update_offering(id: string, input: UpdateOfferingInput): Promise<DiningOffering> {
  const res = await api.patch<DiningOffering>(`/vendor/dining/offerings/${id}`, input);
  return res.data;
}

export async function delete_offering(id: string): Promise<void> {
  await api.delete(`/vendor/dining/offerings/${id}`);
}

// ---- Public ----
export async function fetch_public_offerings(vendor_id: string): Promise<PublicOffering[]> {
  const res = await api.get<PublicOffering[]>(`/user/vendors/${vendor_id}/dining/offerings`);
  return res.data;
}

export async function fetch_offering_availability(service_id: string, date: string): Promise<OfferingAvailability> {
  const res = await api.get<OfferingAvailability>(`/user/dining/offerings/${service_id}/availability`, { params: { date } });
  return res.data;
}
